import { NgxSpinnerService } from 'ngx-spinner';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  constructor(private spinnerService: NgxSpinnerService) { }
  
  public startSpinner(){
    this.spinnerService.show();
  }

  public stopSpinner(){
    this.spinnerService.hide();
  }
}
